const nyymin = 1999;
const nyymax = 2070;
const o2ntbl = [
  [611, 2350],
  [468, 3222],
  [316, 7317],
  [559, 3402],
  [416, 3493],
  [288, 2901],
  [520, 1388],
  [384, 5467],
  [637, 605],
  [494, 2349],
  [343, 6443],
  [585, 2709],
  [442, 2890],
  [302, 5962],
  [533, 2901],
  [412, 2741],
  [650, 1210],
  [507, 2651],
  [369, 2647],
  [611, 1323],
  [468, 2709],
  [329, 5781],
  [559, 1706],
  [416, 2773],
  [288, 2741],
  [533, 1206],
  [383, 5294],
  [624, 2647],
  [494, 1319],
  [356, 3366],
  [572, 3475],
  [442, 1450],
  [302, 5482],
  [546, 2413],
  [414, 2397],
  [650, 1198],
  [507, 2637],
  [370, 6733],
  [598, 3365],
  [455, 3410],
  [317, 6996],
  [559, 2922],
  [416, 2413],
  [288, 2395],
  [533, 1179],
  [397, 5271],
  [624, 2635],
  [481, 2853],
  [343, 5797],
  [585, 1748],
  [429, 2778],
  [302, 4790],
  [546, 2391],
  [424, 2359],
  [650, 1175],
  [507, 1611],
  [370, 3402],
  [598, 3749],
  [455, 1714],
  [316, 5548],
  [559, 2742],
  [429, 2359],
  [289, 2350],
  [520, 3222],
  [384, 6805],
  [624, 3402],
  [468, 3493],
  [343, 2901],
  [585, 1386],
  [442, 2733],
  [303, 4701],
  [546, 2349]
];

const nmdays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
let otbl = new Array(14);

// 簡単なエラーチェック
// tflag : 1 旧暦 , not 1 新暦
function ymdCheck(yy, mm, dd, tflag) {
  let flag = true;

  if (yy < nyymin + 1 || yy > nyymax) flag = false;
  if (tflag === 1) {
    if (Math.abs(mm) < 1 || Math.abs(mm) > 12) flag = false;
    if (dd < 1 || dd > 30) flag = false;
  } else {
    if (mm < 1 || mm > 12) flag = false;
    if (dd < 1 || dd > 31) flag = false;
  }

  return flag;
}

// 新暦→旧暦変換
// 戻り値は Array(nyy,nmm,ndd,uruu)   ・・・ uruu : "閏" or "";
// Errorなら、 Array(0,0,0,"") を返す
export function get_N2O(nyy, nmm, ndd) {
  let oyy, omm, odd, uruu, DofNyy;

  if (!ymdCheck(nyy, nmm, ndd, 0)) return [0, 0, 0, '']; // 入力値チェック（0:新暦）
  DofNyy = NumberDays(nyy, nmm, ndd);
  oyy = nyy;
  TblExpand(oyy);
  if (DofNyy < otbl[0][0]) {
    oyy--;
    DofNyy += 365 + LeapYear(oyy);
    TblExpand(oyy);
  }

  for (let i = 12; i >= 0; i--) {
    if (otbl[i][1] !== 0) {
      if (otbl[i][0] <= DofNyy) {
        omm = otbl[i][1];
        odd = DofNyy - otbl[i][0] + 1;
        break;
      }
    }
  }
  if (omm < 0) {
    uruu = '閏';
    omm = -omm;
  } else {
    uruu = '';
  }
  return [oyy, omm, odd, uruu];
}

// グレゴリウス暦閏年判定。閏年なら 1, 平年なら 0
function LeapYear(yy) {
  let ans = 0;
  if (yy % 4 === 0) ans = 1;
  if (yy % 100 === 0) ans = 0;
  if (yy % 400 === 0) ans = 1;
  return ans;
}

// 新暦年初からの通日 1/1 = 1
function NumberDays(yy, mm, dd) {
  nmdays[1] = 28 + LeapYear(yy);

  let days = dd;
  for (let m = 1; m < mm; m++) {
    days += nmdays[m - 1];
  }
  return days;
}

// 旧暦・新暦テーブル(otbl)作成
function TblExpand(yy) {
  let ommax, days, uruu, bit;

  days = o2ntbl[yy - nyymin][0];
  bit = o2ntbl[yy - nyymin][1];
  uruu = days % 13; // 閏月抽出。無ければ 0
  days = Math.floor(days / 13 + 0.001); // 旧暦年初の新暦年初からの日数

  otbl[0] = [days, 1]; // 旧暦正月の通日と、月数
  if (uruu === 0) {
    bit *= 2; // 閏無しなら 12ヶ月
    ommax = 12;
  } else {
    ommax = 13;
  }

  for (let i = 1; i <= ommax; i++) {
    otbl[i] = [otbl[i - 1][0] + 29, i + 1];
    if (bit >= 4096) {
      otbl[i][0]++; // 大の月
    }
    bit = (bit % 4096) * 2;
  }
  otbl[ommax][1] = 0; // テーブルの終わり＆旧暦翌年年初

  if (ommax > 12) {
    // 閏月のある年
    for (let i = uruu + 1; i < 13; i++) {
      otbl[i][1] = i;
    }
    otbl[uruu][1] = -uruu; // 識別のため閏月はマイナスで記録
  } else {
    otbl[13] = [0, 0]; // 使ってないけどエラー防止で。
  }
}

export const getRokuyo = (year, month, date) => {
  const rokuyo = ['大安', '赤口', '先勝', '友引', '先負', '仏滅'];
  try {
    const qreki = get_N2O(year, month, date); // 年、月、日、閏　の順に答えが返る。
    if (qreki[0] > 0) {
      return rokuyo[(qreki[1] + qreki[2]) % 6]; // 六曜
    } else {
      return '';
    }
  } catch (error) {
    return '';
  }
};
